import { I18nMessages } from "../../../../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages";

export const frGondoles: I18nMessages = {
    'gondoles.navbar': 'Gondoles',
    'gondoles.name': 'Gondole',
    'gondoles.list.title': 'Gondoles',
    'gondoles.list.table.emptyLabel': "Il n'y a pas de gondole pour le moment.",
    'gondoles.list.actions.addGondole': 'Créer un gondole',

    'gondoles.input.name': 'Titre du gondole',
    'gondoles.input.floatingLabelName': 'Titre',
    'gondoles.input.code': 'Référence du gondole',
    'gondoles.input.floatingLabelCode': 'Référence',

    'gondoles.info.description.placeholder': 'Saisissez ici la description du gondole',

    'gondoles.tabs.questions': 'Questions',

    'gondoles.questions.header.recommendations.title': 'Actions sur les recommandations de positionnement',
    'gondoles.questions.header.questions.title': 'Actions sur la liste des questions',

    //* CREATE
    'gondoles.create.pageTitle': 'Création gondole',

    //* DETAILS
    'gondoles.details.actions.previous': 'Gondoles',
    'gondoles.remove.dialog.title': 'Suppression du gondole',
    'gondoles.remove.dialog.content': 'Êtes-vous sûr de vouloir supprimer cette gondole ?',

    'gondoles.clone.dialog.title': 'Copie du gondole',
    'gondoles.clone.dialog.content': 'Voulez-vous créer une copie de ce Gondole ?',

    //* NOTIFICATIONS
    'gondoles.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté cette gondole",

    //* RESULTS
    'gondoles.results.tableHeader.state': 'État de réponse',
    'gondoles.results.details.title': 'Réponse(s) du centre {shop}',

    //* TOAST
    'gondoles.recommendations.import.success': 'Bravo! les recommandations de positionnement ont été importées avec succès',

    //* OTHERS
    'gondoles.permissions.tab.title': 'Gondoles',
    'backofficeUsers.permissions.gondolas.contentcreate': 'Création de gondole',

    'gondoles.questions.answersNeeded.error': "Impossible d'enregistrer ou de publier cette gondole, le nombre de réponses attendues est incohérent pour une ou plusieurs questions"

}